export default __webpack_public_path__ + "static/media/1.f24a4848.png";